import React, { useState, useEffect } from 'react';
import { getArticles } from '../lib/knowledge-base';
import { Link } from 'react-router-dom';

interface Article {
  id: string;
  title: string;
  content: string;
}

const KnowledgeBasePage: React.FC = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      const data = await getArticles();
      setArticles(data);
      setLoading(false);
    };
    fetchArticles();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Knowledge Base</h1>
      <ul>
        {articles.map((article) => (
          <li key={article.id}>
            <Link to={`/knowledge-base/${article.id}`}>{article.title}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default KnowledgeBasePage;
